import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const MediaTextVariantsOuter = styled.div<{
  $orangeDivider?: boolean
  $topPadding: string
  $bottomPadding: string
  $pageType?: string
}>`
  ${({ $orangeDivider, $topPadding, $bottomPadding, $pageType, theme }) => {
    let mainBgColor = ''
    let orangeDivider = ''
    let innerStyles = ''
    let solMtvContainer = ''
    mainBgColor = theme.webMktNewPalette.white

    orangeDivider = $orangeDivider
      ? `position: absolute; content:''; height: 4px; background-color: ${theme.webMktNewPalette.orange[50]}; width: 160px; top: 0; left: 24px;`
      : ''

    innerStyles = `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `
    // Page Solution Tabs Usecase
    if ($pageType === 'solutions') {
      solMtvContainer = `
        max-width: 1523px;
        margin: 0 auto;

        &:before{
          left: 0px;
          right: 0px;
          text-align: center;
          margin: 0 auto;
          
          ${theme.breakpoints.down('xs')} {
            left: 16px;
          }
        }

        .MediaTextV__MainContent{
          margin: 0 auto;
          text-align: center;
          max-width: 100%;
          padding: 0 48px;
          ${theme.breakpoints.down('xs')} {
            padding: 0 16px;
          }
        }
      `
    }

    return `
      ${innerStyles}
      background-color: ${mainBgColor};      
      position: relative;
      max-width: 1920px;
      margin: 0 auto 0 0;
      padding-left: 24px;
      width: calc(100% - 24px);
      ${theme.breakpoints.down('sm')} {
        padding-left: 16px;
      }
      ${theme.breakpoints.down('xs')} {
        padding-left: 0;
      }
      
      
      &:before{
        ${orangeDivider}
        ${theme.breakpoints.down('sm')} {
          left: 16px;
        }
      }

      .MediaTextV__MainContent {
        max-width: 910px;
        padding-right: 32px;
        ${theme.breakpoints.down('xs')} {
          padding: 0 16px;
        }
        .headline {
          margin-bottom: 32px;
        }
        .desc {
          margin-bottom: 64px;
          ${theme.breakpoints.down('xs')} {
            margin-bottom:24px;
          }
          p {
           
          }
        }
      }

      ${solMtvContainer}
    `
  }}
`

export const ColumnLayoutVariantStyle = styled.div`
  h3 {
    margin-bottom: 16px;
  }
  .desc {
    p {
    }
  }
  .Column-image {
    margin-bottom: 64px;
    object-fit: cover;
    max-height: 640px;
    width: 100%;
    max-width: 1920px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin-bottom: 24px;
      padding: 0 16px;
      width: calc(100% - 32px);
    }
  }
  .Column-entries {
    max-width: 910px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      width: calc(100%);
      padding: 0;
      margin: 0;
    }
  }
`

export const TabLayoutVariantStyle = styled.div<{
  $pageType?: string
}>`
  ${({ $pageType, theme }) => {
    // Page Solution Tabs Usecase
    let solTabContainer = ''
    let solTabList = ''
    if ($pageType === 'solutions') {
      solTabList = `
        .Tab__List {
          ul{
            justify-content: flex-start;
            ${theme.breakpoints.down('sm')} {
              justify-content: flex-start;
            }
            li{
              padding: 40px 16px 40px 16px;
              flex: 1;
              min-width: auto;
              ${theme.breakpoints.down('lg')} {
                min-width: auto;
              }
              ${theme.breakpoints.down('sm')} {
                min-width: calc(286px - 56px);
              }
              &:hover {
                background-color: ${theme.webMktNewPalette.deepBlue[10]};
                border-bottom-color: ${theme.webMktNewPalette.orange[50]};
              }
              &.active {
                cursor: default;
                background-color: ${theme.webMktNewPalette.deepBlue[10]};
                border-bottom-color: ${theme.webMktNewPalette.orange[50]};
              }
            }
          }
        }
      `

      solTabContainer = `
        max-width: 1523px;
        margin: 0 auto;

        .Tab__Content {
          .Tab__Content-Left {
            ${theme.breakpoints.down('lg')} {
              padding: 0 16px;
            }
          }

          .Tab__Content-Right {            
            .Tab-image {
              ${theme.breakpoints.down('lg')} {
                padding: 0;
              }
              ${theme.breakpoints.down('sm')} {
                padding: 0 16px;
              }
            } 
          }
        }
      `
    }
    return `
      .Tab__List {
        margin-bottom: 64px;
        ${theme.breakpoints.down('sm')} {
          overflow-x: scroll;
          padding: 0;
        }
        ${theme.breakpoints.down('xs')} {
          padding: 0 16px;
        }
        ul {
          display: flex;
          align-items: flex-end;
          li {
            max-width: 286px;
            min-width: 286px;
            min-height: calc(82px - 32px);
            margin-right: 24px;
            padding: 16px 0;
            font-size: 20px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: -1px;
            color: ${theme.webMktNewPalette.black};
            border-bottom: 2px solid ${theme.webMktNewPalette.deepBlue[10]};
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: flex-end;

            &:last-child{
              margin-right: 0px;
            }

            ${theme.breakpoints.down('lg')} {
              min-width: auto;
            }
            ${theme.breakpoints.down('xs')} {
              min-width: 286px;
            }

            &:hover {
              border-bottom-color: ${theme.webMktNewPalette.black};
            }
            &.active {
              cursor: default;
              border-bottom-color: ${theme.webMktNewPalette.black};
            }
          }
        }
      }

      ${solTabList}

      .Tabs__Container {
        
        .Tab__Content {
          display: none;

          &.active {
            display: flex;
            ${theme.breakpoints.down('sm')} {
              flex-direction: column;
            }
          }

          .Tab__Content-Left {
            max-width: 480px;
            min-width: 480px;
            margin-right: 64px;
            ${theme.breakpoints.down('md')} {
              max-width: 380px;
              min-width: 380px;
              margin-right: 32px;
            }

            ${theme.breakpoints.down('sm')} {
              max-width: 100%;
              margin-right: 0;
              padding: 0 32px 0 0;
            }
            ${theme.breakpoints.down('xs')} {
              min-width: calc(100% - 32px);
              padding: 0 16px;
            }
            .Tab__Content-title {
              margin-bottom: 24px;
            }

            .Tab__Content-desc {
              margin-bottom: 24px;
              p {
               
              }
            }
          }
          .Tab__Content-Right {
            ${theme.breakpoints.down('sm')} {
              margin-top: 48px;
            }
            .Tab-image {
              object-fit: contain;
              object-position: center top;
              min-height: 600px;
              max-height: 600px;
              ${theme.breakpoints.down('md')} {
                min-height: 420px;
              }
              ${theme.breakpoints.down('sm')} {
                min-height: 360px;
                max-height: 400px;
              }
              ${theme.breakpoints.down('xs')} {
                padding: 0 16px;
                width: calc(100% - 32px);
                min-height: auto;
                max-height: auto;
              }
            }
          }
        }
        ${solTabContainer}
      }

      
    `
  }}
`

export const AccordionLayoutVariantStyle = styled.div`
  .Accordion__Container {
    .Accordion__Content {
      display: flex;

      .Accordion__Content-Left {
        max-width: 600px;
        margin-right: 176px;
        ${({ theme }) => theme.breakpoints.down('lg')} {
          margin-right: 24px;
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          max-width: 100%;
          min-width: calc(100% - 32px);
          margin-right: 0;
          margin-top: 24px;
          padding: 0 16px;
        }

        .Item {
          border-top: 2px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
          overflow: hidden;

          .Accordion__Content-text {
            width: 100%;
            text-align: left;
            padding: 20px 0;
            display: flex;
            align-items: center;
            font-weight: 700;
            font-size: 24px;
            line-height: 36px;
            letter-spacing: -1px;
            background: transparent;
            border: none;
            cursor: pointer;
            color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
            svg {
              width: 24px;
              height: 24px;
              transform: rotate(90deg);
              margin-right: 24px;
            }
            &.active {
              display: none;
            }
          }

          .answer-container {
            padding: 0;
            transition: height 0.7s ease-in-out;
            .Accordion__Content-title {
              font-size: 24px;
              font-weight: 700;
              letter-spacing: -1px;
              line-height: 36px;
              margin-bottom: 24px;
              padding-top: 24px;
            }

            .Accordion__Content-desc {
              padding-bottom: 24px;
              p {
              }
            }

            .CTA {
              padding-bottom: 48px;
            }

            .Accordion-image {
              object-fit: cover;
              object-position: center;
              min-height: 600px;
              display: none;

              ${({ theme }) => theme.breakpoints.down('sm')} {
                display: block;
                width: calc(100%);
                max-height: 500px;
                min-height: auto;
              }
            }
          }
        }
      }
      .Accordion__Content-Right {
        .Accordion-image {
          object-fit: cover;
          object-position: center;
          max-height: 600px;
          display: none;
          &.active {
            display: block;
          }
          ${({ theme }) => theme.breakpoints.down('sm')} {
            padding: 0 16px;
            width: calc(100% - 32px);
            min-height: auto;
            &.active {
              display: none;
            }
          }
          ${({ theme }) => theme.breakpoints.down('xs')} {
            min-height: 360px;
          }
        }
      }
    }
  }
`
